import { Button } from '@payaca/ambrosia';
import { FunctionComponent, useCallback, type JSX } from 'react';
import { useHistory } from 'react-router-dom';

import ForgotPasswordForm from '@/ui/components/forgotPasswordForm/ForgotPasswordForm';

import './ForgotPasswordPage.sass';

const ForgotPasswordPage: FunctionComponent = (): JSX.Element => {
  const history = useHistory();

  const goToLoginPage = useCallback(() => {
    history.push('/login');
  }, [history]);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4 typography:prose">
        <h1 className="mb-0 text-[32px] font-bold">Reset your password</h1>
        <p className="text-gray-500">
          Enter the email address you used to create your account, and
          we&apos;ll send you instructions to reset your password.
        </p>
      </div>

      <ForgotPasswordForm />

      <div className="typography:prose">
        <span>
          Remembered it?{' '}
          <Button onClick={goToLoginPage} variant={'link-inline'}>
            Log in
          </Button>
        </span>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
